export default __webpack_public_path__ + "static/media/footer-icon-solana.b21d3c59.svg";